export default __webpack_public_path__ + "static/media/xing.4f0bd8ae.png";